class Obras{
	constructor(){
		this.id = null;
		this.nome = '';
		this.descricao = '';
		this.saldoDisponivel = 0;
		this.saldoDeduzido = 0;
		this.numeroCei = '';
		this.numeroArt = '';
		this.numeroAlvara = '';
		this.dataInicio = null;
		this.dataTermino = null;
		this.enderecoObra = '';
		this.dataInicialFormatada = null;
		this.dataTerminoFormatada = null;
		this.saldoDisponivelFormatado = 0;
		this.saldoDeduzidoFormatado = 0;
		this.numeroCeiAndNomeObra = '';

		//JOINS
		this.idContribuinteCadastro = null;
		this.idCliente = null;
		this.idTipoObra = null;
		this.idTipoAbatimento = null;
	}
}

export default Obras;